// Dynamic Diesels — Search popup.
// Any [data-search-open] trigger opens the modal; backdrop / close button /
// Escape close it. Autofocuses the input; blocks empty submits.

(function () {
  'use strict';

  function init() {
    const modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    const input = modal.querySelector('[data-search-input]');
    const form = modal.querySelector('.dd-search__form');

    function focusInput() {
      if (!input) return;
      input.focus({ preventScroll: true });
    }

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dd-search-open');
      document.body.style.overflow = 'hidden';

      // Focus in the same user-gesture as the tap. A delayed focus() (setTimeout)
      // is ignored by iOS/Android, so the keyboard never opens.
      // Force a reflow first so the input is no longer display:none.
      if (input) {
        void modal.offsetHeight;
        focusInput();
        if (document.activeElement !== input) {
          requestAnimationFrame(focusInput);
        }
      }
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dd-search-open');
      document.body.style.overflow = '';
      const predictive = modal.querySelector('predictive-search');
      if (predictive && typeof predictive.close === 'function') predictive.close();
    }

    document.querySelectorAll('[data-search-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        open();
      });
    });

    modal.querySelectorAll('[data-search-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    modal.addEventListener('click', (e) => {
      if (!modal.classList.contains('is-open')) return;
      if (form && form.contains(e.target)) return;
      close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    if (form) {
      form.addEventListener('submit', (e) => {
        if (input && !input.value.trim()) {
          e.preventDefault();
          input.focus();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
